import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { useDataProvider, useNotify, useTranslate } from 'ra-core';
import { type AdminDataProvider } from '../../adminDataProvider';

type InviteToChannelParams = {
  channelUrl: string;
  userIds: string[];
};

export const useInviteToChannel = (
  options?: UseMutationOptions<void, Error, InviteToChannelParams>
) => {
  const notify = useNotify();
  const translate = useTranslate();
  const dataProvider = useDataProvider<AdminDataProvider>();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['invite-to-channel'],
    mutationFn: ({ channelUrl, userIds }: InviteToChannelParams) =>
      dataProvider.postInviteToChannel(channelUrl, userIds),
    ...options,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: ['channel-members'],
      });
      await options?.onSuccess?.(data, variables, onMutateResult, context);
    },
    onError: async (error, variables, onMutateResult, context) => {
      notify(translate('chat.inviteToChannelError'), {
        autoHideDuration: 5000,
      });
      await options?.onError?.(error, variables, onMutateResult, context);
    },
  });
};
